var React = require('react');

function IconLivraison (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Livraison"),React.createElement("path",{"d":"M57.23,26.76H56.06v-10L49.61,7.36H40.49V0H1.39V26.76H0v4.33H5.84a5.49,5.49,0,0,0,10.68,0H41.85a5.48,5.48,0,0,0,10.68,0h4.7ZM46.46,8.92h2.33l5.71,8.31v1.12h-8Zm-5.76,0h4.2v11h9.6v6.86H51.75a5.51,5.51,0,0,0-9.12,0H40.7Zm-.21,19.41h1.42a6.12,6.12,0,0,0-.2,1.21H16.65a4.94,4.94,0,0,0-.2-1.21h24ZM3,1.56h36v25.2H15.73a5.5,5.5,0,0,0-7.62-1.49,5.29,5.29,0,0,0-1.49,1.49H2.94ZM1.56,28.33H5.9a5.46,5.46,0,0,0-.2,1.21H1.56Zm9.62,5.26a3.76,3.76,0,1,1,3.76-3.76h0a3.77,3.77,0,0,1-3.77,3.76Zm36,0A3.76,3.76,0,1,1,51,29.83h0a3.78,3.78,0,0,1-3.77,3.76Zm8.48-4.05h-3a6.12,6.12,0,0,0-.2-1.21h3.2Z","key":1})]);
}

IconLivraison.defaultProps = {"width":"57","height":"35","viewBox":"0 0 57.23 35.32"};

module.exports = IconLivraison;

IconLivraison.default = IconLivraison;
